import * as React from "react";
import type { SVGProps } from "react";
import { memo } from "react";
const SvgFilter = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M4 7h16M7 12h10M11 17h2"
    />
  </svg>
);
const Memo = memo(SvgFilter);
export default Memo;
